import { FC } from 'react';
import { SplitBillField, SplitBillContainer } from './index.view';
import { useTranslation } from 'react-i18next';
interface SplitBillProps {
  splitAmount: number;
  type?: string;
}

const SplitBill: FC<SplitBillProps> = ({ splitAmount, type }) => {
  const { t } = useTranslation();

  return splitAmount > 0 ? (
    <SplitBillContainer>
      <SplitBillField>
        {type === 'split.amount'
          ? t('splitBillReceiptEquality', { splitAmount })
          : t('splitBillReceiptByItems', { splitAmount })}
      </SplitBillField>
    </SplitBillContainer>
  ) : null;
};

export default SplitBill;
